import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function OnboardingLoad_Promotion() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/promotion-onboarding/start/1", { replace: true });
  }, []);

  // 로딩 중이거나 리다이렉트 전에는 아무것도 렌더링하지 않습니다.
  return <></>;
}
